import React from "react";
import RecipientPicker, { countryLabel } from "./RecipientPicker";
import ReviewField from "./ReviewField";
import CountrySelector from "../../../components/common/CountrySelector";
import { reviewFieldId } from "./Fields";
import DictionaryRecordPicker from "./dictionaries/DictionaryRecordPicker";
import OrderDictionarySave from "./dictionaries/OrderDictionarySave";

/** Edycja odbiorcy niezależna od pozostałych pól projektu. */
export default function RecipientSection({
  recipient,
  candidates,
  roles,
  dictionaryChoices = [],
  dictionaryAccess,
  disabled,
  readOnly,
  onChange,
  onShowSource,
}) {
  const setRecipient = (field, value) =>
    onChange({ ...recipient, [field]: value });
  return (
    <>
      {!readOnly && (
        <>
          <DictionaryRecordPicker
            dictionaries={dictionaryChoices.filter(
              (item) => item.target === "recipient",
            )}
            label="Wybierz odbiorcę ze słownika"
            selectLabel="Użyj tego odbiorcy"
            disabled={disabled}
            onSelect={onChange}
          />
          <RecipientPicker
            candidates={candidates}
            recipient={recipient}
            roles={roles}
            disabled={disabled}
            onSelect={onChange}
            onShowSource={onShowSource}
          />
        </>
      )}
      <div
        className={readOnly ? "premium-recipient-summary" : undefined}
        id={readOnly ? "premium-recipients" : undefined}
      >
        <ReviewField
          readOnly={readOnly}
          className="premium-read-title"
          label="Nazwa odbiorcy"
          id={reviewFieldId("recipient.name")}
          value={recipient.name}
          onChange={(event) => setRecipient("name", event.target.value)}
        />
        <div className={readOnly ? "premium-read-grid" : "premium-grid"}>
          <ReviewField
            readOnly={readOnly}
            label="Adres odbiorcy"
            id={reviewFieldId("recipient.address")}
            value={recipient.address}
            multiline
            onChange={(event) => setRecipient("address", event.target.value)}
          />
          <ReviewField
            readOnly={readOnly}
            label="Kraj odbiorcy"
            id={reviewFieldId("recipient.country")}
            displayValue={countryLabel(recipient.country)}
            editor={
              <div className="premium-field">
                <CountrySelector
                  label="Kraj odbiorcy"
                  inputId={reviewFieldId("recipient.country")}
                  name="premiumRecipientCountry"
                  data={recipient.country}
                  disabled={disabled}
                  onDataChange={(event) =>
                    setRecipient("country", event.target.value)
                  }
                />
              </div>
            }
          />
        </div>
      </div>
      {readOnly && candidates?.length > 0 && (
        <details
          className="premium-read-sources"
          id="premium-recipient-evidence"
        >
          <summary>Odbiorcy w dokumentach źródłowych</summary>
          <RecipientPicker
            candidates={candidates}
            recipient={recipient}
            roles={roles}
            readOnly
            onShowSource={onShowSource}
          />
        </details>
      )}
      {!readOnly && dictionaryAccess && (
        <OrderDictionarySave
          {...dictionaryAccess}
          target="recipient"
          value={recipient}
          disabled={disabled}
          label="Zapisz odbiorcę w słowniku"
        />
      )}
    </>
  );
}
